import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '@blk/cwp-ng-framework';
import { ErrorHandlerServiceDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-error-page',
	templateUrl: './error-page.component.html',
	styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
	private readonly DCR_PREFIX = 'ERROR_';
	private readonly DCR_TITLE = '_TITLE';
	private readonly DCR_DESC = '_DESC';

	public errorTitle: string;
	public errorDesc: string;

	constructor(private route: ActivatedRoute, private contentService: ContentService) { }

	public ngOnInit(): void {
		const routeParams = this.route.snapshot.queryParams;
		const errorType = get(routeParams, 'errorType', 'DEFAULT').toUpperCase().replace(/-/g, '_');

		const dcrLabels = this.DCR_PREFIX + errorType;

		this.errorTitle = this.contentService.get(ErrorHandlerServiceDCR[dcrLabels + this.DCR_TITLE], ErrorHandlerServiceDCR[dcrLabels + this.DCR_TITLE]);
		this.errorDesc = this.contentService.get(ErrorHandlerServiceDCR[dcrLabels + this.DCR_DESC], ErrorHandlerServiceDCR[dcrLabels + this.DCR_DESC]);
	}

}
